<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'900px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"
    >
      <template #body>
        <h3 class="dialogTitle margin-left-5">Chọn thư mục</h3>
        <template>
          Loại lưu trữ:&nbsp;&nbsp;
          <el-radio-group v-model="saveType">
            <el-radio :label="'LUU_COPY'">Lưu bản sao</el-radio>
            <el-radio :label="'LUU_LIEN_KET'" aria-checked="true">Lưu liên kết</el-radio>
          </el-radio-group>
        </template>
        <br/>
        <br/>
        <template>
          Vị trí lưu:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <el-radio-group v-model="savePlaceType">
            <el-radio :label="DON_VI">Thư mục đơn vị</el-radio>
            <el-radio :label="CA_NHAN">Thư mục cá nhân</el-radio>
          </el-radio-group>
        </template>
        <br/>
        <br/>
        <div>
          <el-input
            placeholder="Tìm kiếm thư mục"
            v-model="filterText">
          </el-input>
        </div>
        <br/>
        <div>
          <el-tree
            class="tree-index"
            :data="folderTree"
            accordion
            show-checkbox
            check-strictly
            node-key="id"
            :props="defaultProps"
            :filter-node-method="filterNode"
            @check="setCheckedKeys"
            ref="tree"
            :highlight-current="true"
          >
            <div
              class="custom-tree-node flex-row flex__between width__100"
              slot-scope="{ node, data }"
            >
              <div class="field-1">
                                  <span>
                                   <i class="fas fa-folder"></i>
                                    <span>&nbsp;{{ data.name }}</span>
                                  </span>
              </div>
            </div>
          </el-tree>
        </div>
      </template>
      <template #footer>
        <div class="flex-row flex__left form-button__action margin-top-10">
          <el-button
            type="success"
            size="mini"
            class="addDocs btn-none__border  color__white bg__blue"
            @click="save"
          >
            <span class="flex-row flex__center">
              <i class="fas fa-save font-size__medium"></i>
              &nbsp;&nbsp;Lưu
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            @click="$emit('closeDialog')"
          >
            <span class="flex-row flex__center">
              <i class="far fa-times-circle font-size__medium"></i>
              &nbsp;&nbsp;Bỏ qua
            </span>
          </el-button>
        </div>
      </template>
    </dialogTemplate>
  </div>
</template>

<script>
import dateFormatter from "../../../filters/dateFormatter";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import h from "../../../services/h";
import constants from "../../../constants";
import vbOutgoingDocCopyService from "../../../services/vbOutgoingDocCopyService";
import vbIncomingDocCopyService from "../../../services/vbIncomingDocCopyService";
import folderAccessoryService from "../../../services/folderAccessoryService";
import uuidv4 from "uuid/v4";
import tkTaskCopyService from "../../../services/tkTaskCopyService";

export default {
  mixins: [handleRequestErrorMixin],
  name: "tree-document-dialog",
  props: ["isOpen", "vbId", "accessoryType"],
  filters: {dateFormatter},
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    selectDepartmentDialog: () =>
      import("../../common/commonSelectDepartmentDialog")
  },
  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    vbIncomingDocCopyId() {
      return uuidv4()
    },
    vbOutgoingDocCopyId() {
      return uuidv4()
    },
  },
  data() {
    return {
      saveType: constants.QUAN_LY_TAI_LIEU.LUU_COPY,
      savePlaceType: constants.QUAN_LY_TAI_LIEU.GROUP.DON_VI,
      isOpenDialogCreate: true,
      folders: [],
      folderTree: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      errorMessageFilter: [],
      filterText: '',
      DON_VI: constants.QUAN_LY_TAI_LIEU.GROUP.DON_VI,
      CA_NHAN: constants.QUAN_LY_TAI_LIEU.GROUP.CA_NHAN,
    }

  }
  ,
  created() {
    this.loadFolders()
  }
  ,

  watch: {
    savePlaceType() {
      this.loadFolders()
    }
    ,
    filterText(val) {
      this.$refs.tree.filter(val);
    }

  }
  ,
  methods: {
    setCheckedKeys(item) {
      this.$refs.tree.setCheckedKeys([item.id]);
      this.folderId = item.id
    }
    ,
    loadFolders() {
      let form = {
        // userId: this.$store.getters.user.id,
        // roleId: this.$store.getters.userDeptRole.roleId,
        // deptId: this.$store.getters.userDeptRole.deptId,
        groupAccessory: this.savePlaceType
      }
      folderAccessoryService
        .findTreeFolder(form)
        .then(response => {
          this.folders = response.data;
          this.buildFolderTree();

        })
    }
    ,
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    }
    ,

    save() {
      if (this.validate()) {
        // trường hợp lưu liên kết vào trong thư mục
        if (this.saveType === constants.QUAN_LY_TAI_LIEU.LUU_LIEN_KET) {
          let form = {
            objectIds: [this.vbId],
            folderId: this.folderId
          }
          if (this.accessoryType === constants.QUAN_LY_TAI_LIEU.VB_DEN) {
            form.type = constants.QUAN_LY_TAI_LIEU.TYPE.VB_DEN_LINK
          } else if (this.accessoryType === constants.QUAN_LY_TAI_LIEU.VB_DI) {
            form.type = constants.QUAN_LY_TAI_LIEU.TYPE.VB_DI_LINK
          } else if (this.accessoryType === constants.QUAN_LY_TAI_LIEU.CONG_VIEC) {
            form.type = constants.QUAN_LY_TAI_LIEU.TYPE.CONG_VIEC_LINK
          }
          console.log('form', form)
          folderAccessoryService.saveLink(form).then(response => {
            this.$message({message: 'Liên kết vào thư mục thành công', type: 'success'});
            this.$emit('closeDialog')
          }).catch(error => this.commonHandleRequestError(error));
        } else if (this.saveType === constants.QUAN_LY_TAI_LIEU.LUU_COPY) {
          let form = {
            folderId: this.folderId,
            ids: [this.vbId]
          }
          // văn bản đến copy
          if (this.accessoryType === constants.QUAN_LY_TAI_LIEU.VB_DEN) {
            vbIncomingDocCopyService.saveCopy(form).then(response => {
              this.$message({message: 'Sao chép thành công văn bản', type: 'success'});
              this.$emit('closeDialog')
            }).catch(error => this.commonHandleRequestError(error));

          }
          // văn bản đi copy
          else if (this.accessoryType === constants.QUAN_LY_TAI_LIEU.VB_DI) {

            vbOutgoingDocCopyService.saveCopy(form).then(response => {
              this.$message({message: 'Sao chép thành công văn bản', type: 'success'});
              this.$emit('closeDialog')
            }).catch(error => this.commonHandleRequestError(error));

          }
          // công việc copy
          else if (this.accessoryType === constants.QUAN_LY_TAI_LIEU.CONG_VIEC) {
            tkTaskCopyService.saveCopy({
              parentId: this.folderId,
              taskIds: [this.vbId],
              userId: this.$store.getters.userDeptRole.userId,
              deptId: this.$store.getters.userDeptRole.deptId,
              roleId: this.$store.getters.userDeptRole.roleId,
            }).then(response => {
              this.$message({message: 'Sao chép thành công công việc', type: 'success'});
              this.$emit('closeDialog')
            }).catch(error => this.commonHandleRequestError(error));
          }
        }
      }
    }
    ,
    validate() {
      if (!this.folderId) {
        this.$message.error('Chưa chọn thư mục để đưa hồ sơ vào');
        return false
      }
      return true
    },
    buildFolderTree() {
      this.folderTree = [];
      // build parent folder
      let roots = [];
      // tim ra nhung node co con co parentid khong trung voi id nao trong list lay ra
      for (let i = 0; i < this.folders.length; i++) {
        if (this.folders[i].parentId === 'root') {
          roots.push(this.folders[i])
        } else {
          let tem = 0
          for (let j = 0; j < this.folders.length; j++) {
            if (this.folders[i].parentId === this.folders[j].id) {
              tem = tem + 1
            }
          }
          if (tem < 1) {
            roots.push(this.folders[i])
          } else {
            tem = 0
          }
        }
      }

      h.each(roots, item => this.buildFolderTreeForNode(item));
      h.each(roots, item => this.folderTree.push(item));
    }
    ,

    buildFolderTreeForNode(node) {

      let children = []
      this.folders.forEach(item => {
        if (item.parentId === node.id) {
          children.push(item)
        }
      })
      node.children = children
      if (children.length > 0) {
        children.forEach(child => {
          this.buildFolderTreeForNode(child);
        })
      }
    }
    ,
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/setting/quanLyTaiLieu/treeFolderDialog.vue